import { render, staticRenderFns } from "./zxservice.vue?vue&type=template&id=f17729b4&scoped=true"
import script from "./zxservice.vue?vue&type=script&lang=js"
export * from "./zxservice.vue?vue&type=script&lang=js"
import style0 from "./zxservice.vue?vue&type=style&index=0&id=f17729b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17729b4",
  null
  
)

export default component.exports